import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
 providedIn: 'root'
})
export class EncryptionService {
 private readonly secretKey = 'poliPay2024!@#';
 private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    // Verificamos síncronamente si estamos en el navegador al momento de la construcción
    this.isBrowser = isPlatformBrowser(this.platformId); 
    // Si no estamos en el navegador, alertamos, pero no fallamos
    if (!this.isBrowser) {
        console.warn('EncryptionService: Running in a non-browser environment. Encryption/Decryption will use fallback/be disabled.');
    }
  }

  /**
   * Encripta un valor usando base64 y una clave secreta (solo en el navegador).
   * Usa TextEncoder para soportar Unicode (acentos, emojis, etc.).
   * @param value El valor a encriptar
   * @returns El valor encriptado o una cadena vacía si no es un navegador.
   */
  encrypt(value: string | number): string {
    if (!this.isBrowser) {
      return '';
    }
    const stringValue = value.toString();
    const combinedValue = this.secretKey + stringValue;
    const bytes = new TextEncoder().encode(combinedValue);
    return btoa(String.fromCharCode(...bytes));
  }

  /**
   * Desencripta un valor previamente encriptado (solo en el navegador).
   * Soporta datos con Unicode. Fallback al formato legacy si falla (compatibilidad).
   * @param encryptedValue El valor encriptado
   * @returns El valor original
   */
  decrypt(encryptedValue: string): string {
    if (!this.isBrowser) {
        return '';
    }
    try {
      const bytes = Uint8Array.from(atob(encryptedValue), c => c.charCodeAt(0));
      const decodedValue = new TextDecoder().decode(bytes);
      return decodedValue.startsWith(this.secretKey) ? decodedValue.slice(this.secretKey.length) : decodedValue;
    } catch {
      try {
        const decodedValue = atob(encryptedValue);
        return decodedValue.startsWith(this.secretKey) ? decodedValue.slice(this.secretKey.length) : decodedValue;
      } catch (error) {
        console.error('Error al desencriptar. Asegúrese de que el valor fue encriptado con la misma clave:', error);
        return '';
      }
    }
  }
}